import { Menu, MenuItemProps } from '@mantine/core';
import { RouteParams } from 'atomic-router';
import { Link, LinkProps } from 'atomic-router-react';
import cls from './nav-menu.module.scss';

type NavMenuItemProps<TParams extends RouteParams> = LinkProps<TParams> & MenuItemProps;

export const NavMenuItem = <TParams extends RouteParams>({
	children,
	...props
}: NavMenuItemProps<TParams>) => (
	<Menu.Item
		component={Link<TParams>}
		classNames={{
			item: cls.navMenuItem,
			itemLabel: cls.navMenuItemLabel,
		}}
		activeClassName={cls.navMenuItemActive}
		{...props}
	>
		{children}
	</Menu.Item>
);
